
import React, { useEffect } from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import { Container, Row, Col } from 'react-bootstrap';
import productbanner from '../Assets/Image/NamkeenProducts_Banner.jpg';
import '../Assets/WebsiteCss/product.css';
import { Helmet } from "react-helmet";


import sohanpapadi from '../Assets/Image/Sohan Papdi.jpg'
import alubhujiya from '../Assets/Image/alubhujiya.png'
import dryfruitmix from '../Assets/Image/DryfruitMix.png'
import chanamasala from '../Assets/Image/cganajormasala.png'
import indori from '../Assets/Image/endorikhattamitha.png'
import fariyalisabudana from '../Assets/Image/FariyaliSabudana.png'
import gujaratimix from '../Assets/Image/Gujaratimix.png'
import moongdal from '../Assets/Image/MoongdalMasala.png'
import nadiyadimix  from '../Assets/Image/NadiyadiMix.png'
import chidchidpapdi  from '../Assets/Image/ChidChidPapad.png'
import kashmirimix from '../Assets/Image/KashmiriMix.png'
import ratlamisev from '../Assets/Image/RatlamiMix.png'
import ujainisev from '../Assets/Image/ujjainsev.png'
import palakbesansev from '../Assets/Image/Palaksev.png'
import masallachidchidpapdi from '../Assets/Image/MasalaChidchdpapadi.png'
import sabudanakhichadi from '../Assets/Image/sabudanakhichadi.png'
import hingumasalasev from '../Assets/Image/HinguMasalasev.png'
import tamatarbesansev from '../Assets/Image/TamatarSev.png'
import lasansev from '../Assets/Image/LahasanSev.png'
import bhavnagrisev from '../Assets/Image/BhavnagariGathiya.png'
import farilimitha from '../Assets/Image/fariyarimix.png'
import Fariyalicharka from '../Assets/Image/fariyarimasalamix.png'
import gujaratipapdi from '../Assets/Image/Gujaratimix.png'
import stargathiya from '../Assets/Image/stargathitabade.png'
import charkibundi from '../Assets/Image/charkibundi.png'
import fikibundi from '../Assets/Image/fikibundi.png'
import panjabimix from '../Assets/Image/panjabimix.png'
import alubhavabhujiya from '../Assets/Image/alubhavabhujiya.png'
import masalachanadal from '../Assets/Image/masalachanadal.png'
import podinadal from '../Assets/Image/podinadal.png'
import hingmix from '../Assets/Image/hingmix.png'
import milkcake from '../Assets/Image/milkcake.jpg';
import malaichamcham from '../Assets/Image/malaichamcham.jpg';
import dryfruitcake from '../Assets/Image/dryfruitcake.jpg';
import malairoll from '../Assets/Image/malairoll.jpg';
import anjeerkatli from '../Assets/Image/anjeerkatli.jpg';
import anjeerroll from '../Assets/Image/anjeerroll.jpg';


export default function Products() {
  useEffect(() => {
        AOS.init({ duration: 1000, once: true });
      }, []);

  const products = [
    
    { name: "Sohan Papdi", image:sohanpapadi },
    { name: "Alu Bhujiya", image: alubhujiya},
    { name: "Dry Fruit Mix", image: dryfruitmix },
    { name: "Chana Jor Masala", image: chanamasala },
    { name: "Indori Khatta Mitha", image: indori },
    { name: "Fariyali Sabudana", image: fariyalisabudana },
    { name: "Moong Daal (Masala)", image: moongdal },
    { name: "Nadiyadi Mix", image: nadiyadimix },
    { name: "Chid Chid Papdi", image: chidchidpapdi },
    { name: "Kashmiri Mix", image: kashmirimix },
    { name: "Ratlami Sev", image: ratlamisev },
    { name: "Ujaini Sev", image: ujainisev },
    { name: "Palak Besan Sev", image: palakbesansev },
    { name: "Masala Chid Chid Papdi", image: masallachidchidpapdi },
    { name: "Fariyali Sabudana Khichdi", image: sabudanakhichadi },
    { name: "Hingu Masala Sev", image: hingumasalasev },
    { name: "Tamatar Besan Sev", image: tamatarbesansev },
    { name: "Lasan Sev", image: lasansev },
    { name: "Bhavnagri Gathiya", image: bhavnagrisev },
    { name: "Fariyali Mitha Mix", image: farilimitha },
    { name: "Fariyali Charka Mix", image: Fariyalicharka },
    { name: "Gujarati Papdi", image: gujaratipapdi },
    { name: "Start Gathiya", image: stargathiya },
    { name: "Charki Bundi ", image: charkibundi },
    { name: "Fiki Bundi", image: fikibundi },
    { name: "Panjabi Mix", image: panjabimix },
    { name: "Chana Jor Masala", image: chanamasala },
    { name: "Hing Mix", image: hingmix },
    { name: "Alu Bhava Bhujiya", image: alubhavabhujiya },
    { name: "Masala Chana Dal", image: masalachanadal },
    { name: "Podina Dal", image: podinadal },
      { name: "Milk Cake ", image: milkcake },
  { name: "Malai Chamcham ", image: malaichamcham },
  { name: "Dry Fruit Cake ", image: dryfruitcake },
  { name: "Malai Roll ", image: malairoll },
  { name: "Anjeer Katli ", image: anjeerkatli },
  { name: "Anjeer King Roll ", image: anjeerroll },
];
 


  return (
    <>
      <div className="mainnav min-vh-100">
        
  <Helmet>
    <title>Taste the Tradition – Our Namkeen Range | Narayan Salvi Namkeen Contractor</title>

    <meta
      name="description"
      content="Explore 300+ premium namkeen varieties by Narayan Salvi – from Ratlami Sev to Indori Khatta Meetha and Fariyali Mix. Experience authentic taste from a trusted name with 27+ years of excellence."
    />

    <meta
      name="keywords"
      content="Namkeen Products, Indian Snacks, Ratlami Sev, Indori Mixture, Fariyali Snacks, Narayan Salvi Namkeen, Namkeen Range, Traditional Snacks, Bhujiya, Papdi, Masala Dal"
    />

    <meta name="author" content="Narayan Salvi Group" />

    {/* Open Graph for social media sharing */}
    <meta property="og:title" content="Taste the Tradition – Our Namkeen Range" />
    <meta
      property="og:description"
      content="Handcrafted namkeen from Narayan Salvi – 300+ varieties, authentic flavors, pan India delivery."
    />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://nsnamkeenlabourcontractor.com/ourproducts" />
    <meta property="og:image" content="https://nsnamkeenlabourcontractor.com/static/media/NamkeenProducts_Banner.f1ec1b5eefa8e62df074.jpg" />

    {/* Responsive viewport */}
    <meta name="viewport" content="width=device-width, initial-scale=1" />

    {/* Favicon */}
    <link rel="icon" href="/favicon.ico" />
  </Helmet>
        
        {/* Banner */}
        <div className="service-container ">
          <img src={productbanner} alt="" className="servicenamkken img-fluid" />
          <div className="service-text">"Taste the Tradition – Our Namkeen Range"</div>
        </div>

        {/* Product Intro */}
        <Container className="py-3">
          <div className="text-center mb-4">
            <h2 className="middletext mb-3" data-aos="zoom-in">
              Explore Our Delicious Products
            </h2>
            <p className="text-muted">
              Explore over 300+ delicious varieties handcrafted by Narayan Salvi with 27+ years of experience. From crispy snacks to flavorful mixtures, we deliver authentic taste across India.
            </p>
          </div>

      <Row className='m-0'>
  {products.map((product, index) => (
    <Col md={3} sm={6} xs={6} key={index} className="mb-4">
      <div className="productser-card shadow-sm">
        <img src={product.image} alt={product.name} className="productser-img" />
        <div className="productser-overlay">
          {product.name}
        </div>
      </div>
    </Col>
  ))}
</Row>

        </Container>
      <section className="gallery-section py-5">
      <Container>
       <div className="text-center mb-4">
            <h2 className="middletext mb-3" data-aos="zoom-in">
          Our Gallery
        </h2>
        </div>
<Row className="gx-4 gy-2 justify-content-center">

  {/* Video 1 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="100">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
        src="https://www.youtube.com/embed/na8fPj88wss"
        title="YouTube Shorts Video 1"
        allowFullScreen
        style={{ width: "100%", height: "90%", borderRadius: "12px" }}
      ></iframe>
    </div>
  </Col>

  {/* Video 2 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="200">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
        src="https://www.youtube.com/embed/MPBDrcDGcnQ"
        title="YouTube Shorts Video 2"
        allowFullScreen
        style={{ width: "100%", height: "90%", borderRadius: "12px" }}
      ></iframe>
    </div>
  </Col>

  {/* Video 3 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="300">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
        src="https://www.youtube.com/embed/DNln79CHLZY"
        title="YouTube Shorts Video 3"
        allowFullScreen
        style={{ width: "100%", height: "90%", borderRadius: "12px" }}
      ></iframe>
    </div>
  </Col>

  {/* Video 4 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="400">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
        src="https://www.youtube.com/embed/Tz4CaiEpaCo"
        title="YouTube Shorts Video 4"
        allowFullScreen
        style={{ width: "100%", height: "90%", borderRadius: "12px" }}
      ></iframe>
    </div>
  </Col>

  {/* Video 5 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="500">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
        src="https://www.youtube.com/embed/6E1gn8q-Cq8"
        title="YouTube Shorts Video 5"
        allowFullScreen
        style={{ width: "100%", height: "90%", borderRadius: "12px" }}
      ></iframe>
    </div>
  </Col>

  {/* Video 6 */}
  <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="600">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
  src="https://www.youtube.com/embed/dc5pg-a3FcA"
  title="YouTube Shorts Video 6"
  allowFullScreen
  style={{ width: "100%", height: "90%", borderRadius: "12px", border: "none" }}
></iframe>

    </div>
  </Col>

   <Col md={4} sm={6} xs={12} data-aos="zoom-in" data-aos-delay="600">
    <div style={{ width: "360px", height: "440px", margin: "0 auto" }}>
      <iframe
  src="https://www.youtube.com/embed/H99YKxyQiw0"
  title="YouTube Shorts Video 7"
  allowFullScreen
  style={{ width: "100%", height: "90%", borderRadius: "12px", border: "none" }}
></iframe>


    </div>
  </Col>
</Row>


      </Container>
    </section>
      </div>
    </>
  );
}
